import { render, staticRenderFns } from "./AdminCustomerPricing.vue?vue&type=template&id=7abc703c&scoped=true"
import script from "./AdminCustomerPricing.vue?vue&type=script&lang=js"
export * from "./AdminCustomerPricing.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomerPricing.vue?vue&type=style&index=0&id=7abc703c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc703c",
  null
  
)

export default component.exports